import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.264 3.09a.394.394 0 0 0-.261-.09c-.105 0-.2.035-.263.09l-9.437 8.433 2.708 1.007.044.645.51 7.495c.013.178.166.325.324.325L9.52 21c.135 0 .259-.122.259-.24v-5.654c0-.89.686-1.606 1.598-1.606h1.222c.89 0 1.624.718 1.624 1.607v5.654c0 .137.1.239.225.239h3.68c.154 0 .306-.144.32-.326l.58-8.142.6-.226 2.074-.78-9.437-8.436zM12.003 2c.336 0 .672.115.929.345l9.737 8.706c.516.461.417 1.024-.216 1.261l-2.474.93-.535 7.503c-.052.707-.64 1.255-1.317 1.255h-3.68a1.228 1.228 0 0 1-1.225-1.239v-5.653a.62.62 0 0 0-.624-.608h-1.222c-.358 0-.598.268-.598.606v5.654c0 .675-.577 1.24-1.258 1.24l-3.632-.005c-.693-.001-1.273-.564-1.32-1.256l-.511-7.497-2.5-.93c-.647-.24-.74-.802-.227-1.26l9.744-8.707c.258-.23.594-.345.929-.345z"
});

var SvgHome = function SvgHome(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgHome;